import type { ReactNode } from "react";
import { useAuth } from "@/lib/auth-store";
import { LoginPage } from "@/pages/LoginPage";

/**
 * Gates the entire app behind authentication. If no admin token is set,
 * render the login page; otherwise render children (the app shell).
 *
 * The API client clears the token on 401, which automatically takes the
 * user back here.
 */
export function LoginGate({ children }: { children: ReactNode }) {
  const token = useAuth((s) => s.token);
  if (!token) return <LoginPage />;
  return <>{children}</>;
}
